import React from "react";
import { Link } from 'react-router-dom'

import Container from '../../components/Container'
import Hero from '../../components/Hero'
import Header from '../../components/Header/brandbook'
import Section from '../../components/Section'
import Icon from '../../components/Icon'
import IconDemo from '../../components/IconDemo'
import Downloadable from '../../components/Downloadable'
import Grid from '../../components/Grid'

export const path = '/brandbook/typography'

export default function BrandbookPage() {
  return (
    <div className="light">
      <Header />
      <Hero>
        <Container size="large">

          <Grid grid="1-2">
            <></>
            <>
              <h1><span className="highlight">Tools and Rules</span> <br />Typography</h1>
            </>
          </Grid>
        </Container>

      </Hero>
      <Container size="large">

    <Section>
      <Grid grid="1-2">
        <></>
        <>
          <p>We use Karelia from the Norwegian type foundry Monokrom as our primary typeface. The font has a slightly mechanical feel with strict caracteristic shapes. It works just as well for larger headlines as for smaller screens and user interfaces.</p>
        </>
      </Grid>
      <h1 style={{fontSize: "322px", marginBottom: "40px"}}>AaBbCcDdEeFfGg<br />0123456789</h1>



      <Grid grid="1-2">
        <></>
        <>

          <p>We use the following principles to ensure maximum readability and visual hierarchy. As a rule of thumb the line height should be set 120 - 140%, depending on context and amount of text. </p>

          <h1>Headline</h1>
          <p>Karelia Medium. Set with 120 % line height. </p>

          <h2>Subtitle</h2>
          <p>Karelia Medium. Should be set in 45 - 55% of previous title size with 130 % line height. </p>

          <h3>Subtitle 2</h3>
          <p>Karelia Bold. Should be set in 45 - 55% of previous title size with 140 % line height. </p>

          <p>Paragraphs<br />Karelia Regular. Paragraphs should be set in 20 - 30% of title size with 140 % line height. </p>
</>
          </Grid>
        </Section>
        <Section>
        <Grid grid="1-2">
          <></>
          <>

          <h2>Related</h2>

          <Downloadable>
            <IconDemo><Icon icon="externalLink" /></IconDemo>
            <div className="downloadable__content">

              <h3><a href="https://monokrom.no/fonts/karelia" rel="noopener noreferrer" target="_blank">Monokrom Skriftforlag</a></h3>
              <p>Buy a font license from the creators of Karelia. </p>
            </div>
          </Downloadable>

          <Downloadable>
            <IconDemo><Icon icon="download" /></IconDemo>
            <div className="downloadable__content">

              <h3><a href="/assets/fonts/">Karelia Bold</a></h3>
              <p>Download desktop font (OTF file). </p>
            </div>
          </Downloadable>

          <Downloadable>
            <IconDemo><Icon icon="download" /></IconDemo>
            <div className="downloadable__content">
              <h3><a href="/assets/fonts/">Karelia Medium</a></h3>
              <p>Download desktop font (OTF file). </p>
            </div>
          </Downloadable>

          <Downloadable>
            <IconDemo><Icon icon="download" /></IconDemo>
            <div className="downloadable__content">
              <h3><a href="/assets/fonts/">Karelia Regular</a></h3>
              <p>Download desktop font (OTF file). </p>
            </div>
          </Downloadable>
        </>
      </Grid>

    </Section>

    <br />
    </Container>
    </div>
    )
  }
